import { createRoute } from '@/utils/routing'

export const RATE_LIST_ROUTE = 'rates'

export function createRateListRoute (options = {}) {
  return createRoute(RATE_LIST_ROUTE, options)
}
